import { render, staticRenderFns } from "./LayoutOnboarding.vue?vue&type=template&id=18585bb5&scoped=true"
import script from "./LayoutOnboarding.vue?vue&type=script&lang=js"
export * from "./LayoutOnboarding.vue?vue&type=script&lang=js"
import style0 from "./LayoutOnboarding.vue?vue&type=style&index=0&id=18585bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18585bb5",
  null
  
)

export default component.exports